import axios from 'axios';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';
import config from '../../../../core/config/configureSettings';

export const getReports = () => {
  const serviceURL = constructServiceURL({
    endpoint: 'getReports',
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceURL);
};

export default getReports;
